<template>
  <div class="input-container">
    <div class="input__label">
      Street Address
    </div>
    <input
      id="us_address"
      v-model.lazy="$v.usAddress.$model"
      class="input"
      :class="{'input--error' : ($v.usAddress.$invalid === true && $v.usAddress.$error === true)}"
      type="text"
      name="us_address"
      @focusout="updateAddress"
    >
    <span
      v-show="$v.usAddress.$invalid === true && $v.usAddress.$error === true"
      class="input__error"
    >
      Invalid address. Example: 123 street name
    </span>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  props: {
    streetAddress: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      usAddress: ''
    }
  },
  watch: {
    '$v.usAddress.$invalid': function (val) {
      if (val === false) {
        this.$emit('input', this.usAddress)
      }
      this.$emit('valid', (val === false), this.$options._componentTag)
      this.$emit('update', 'HomeAddress', this.usAddress)
    }
  },
  validations: {
    usAddress: {
      required,
      isValid (usAddress) {
        return !!usAddress.trim().replace(/\s/g, '').replace(/[!@#$%^&*(),.?":{}|/<>-]/g, '').match(/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9.]+)$/)
      }
    }
  },
  mounted () {
    if (this.streetAddress) { this.usAddress = this.streetAddress }
  },
  methods: {
    updateAddress () {
      if (this.usAddress.$invalid !== true && this.usAddress.$error !== true) {
        this.$emit('input', this.usAddress)
      }
    },
    triggerTouch () {
      this.$v.$touch()
    }
  }
}
</script>
